import View from './View'
import { TweenMax, TimelineMax, Power0, Power1, Power2, Power3, Power4, Back, Bounce, Elastic, Expo, Sine } from 'gsap'


class CharacterContentView extends View {

  constructor(id) {
    super(id)
  }
  /**
  * animate in (show)
  **/  
  show(container) {
    super.show(container)
    const circle = container.querySelector(".circle")
    const title = container.querySelector(".title-attr")
    const info = container.querySelector(".info-attr")
    const cfa = container.querySelector(".cfa-wrapper")
    if (circle) {
      TweenMax.killTweensOf(circle)
      TweenMax.set(circle, {scale: .5, opacity: 0})
      TweenMax.to(circle, 2, {scale: 1, opacity: 1, ease: Expo.easeOut})
    }
    if (title) {
      TweenMax.killTweensOf(title)
      TweenMax.set(title, {scale: .85, opacity: 0})
      TweenMax.to(title, .5, {scale: 1, opacity: 1, delay: .1, ease: Power2.easeOut})
    }
    if (info) {
      TweenMax.killTweensOf(info)
      TweenMax.set(info, {opacity: 0})
      TweenMax.to(info, .8, {opacity: 1, delay: .3, ease: Sine.easeOut})
    }
    if (cfa) {
      TweenMax.killTweensOf(cfa)
      TweenMax.set(cfa, {y: 20, opacity: 0})
      TweenMax.to(cfa, .5, {y: 0, opacity: 1, delay: .7, ease: Back.easeOut})
    }
  }
  /**
  * animate out (hide)
  **/
  hide(container) {
    super.hide(container)
    const circle = container.querySelector(".circle")
    const title = container.querySelector(".title-attr")
    const info = container.querySelector(".info-attr")
    const cfa = container.querySelector(".cfa-wrapper")
    if (circle) {
      TweenMax.killTweensOf(circle)
      TweenMax.to(circle, .5, {scale: .6, opacity: 0, delay: .4, ease: Power2.easeIn})
    }
    if (title) {
      TweenMax.killTweensOf(title)
      TweenMax.to(title, .5, {scale: .9, opacity: 0, delay: .3, ease: Power2.easeIn})
    }
    if (info) {
      TweenMax.killTweensOf(info)
      TweenMax.to(info, .6, {opacity: 0, delay: .2, ease: Sine.easeIn})
    }
    if (cfa) {
      TweenMax.killTweensOf(cfa)
      TweenMax.to(cfa, .5, {y: 10, opacity: 0, delay: 0, ease: Back.easeIn})
    }
  }

}

export default CharacterContentView